export const getUserDetails = async (api) => {
    const response = await api
      .get(`SystemManagement/Users/GetUserDetails/`)
      .then((res) => res)
      .catch((err) => err);
  
    return response;
  };